"use strict";

import angular from "angular";

import "./accounting/accounting.module";
import "./accountings/accountings.module";
import "./admin-users/admin-users.module";
import "./authentication/authentication.module";
import "./home/home.module";
import "./logout/logout.module";
import "./plans/plans.module";
import "./privacy-policy/privacy-policy.module";
import "./public-variables-indicators-charts/public-variables-indicators-charts.module";
import "./trials/trials.module";

angular.module("nucont.views", [
    "nucont.accounting",
    "nucont.home",
    "nucont.authentication",
    "nucont.logout",
    "nucont.plans",
    "nucont.privacyPolicy",
    "nucont.accountings",
    "nucont.adminUsers",
    "nucont.publicVariablesIndicatorsCharts",
    "nucont.trials"
]);
angular.module("nucont").requires.push("nucont.views");
